export default `---
slug: peru
country: Peru
countryCode: PER
continent: America
year: 2025
title: "Peru"
description: "Ancient Inca temples, the Amazon basin, and the world's most dramatic mountain landscapes — South America's crown jewel."
thumbnail: /images/travels/PER/peru_thumb.jpg
relatedLinks: []
---

*Story coming soon — stay tuned!*
`;
